
const formatDate = (date) => {
    const convertedDate = new Date(date);
    return convertedDate.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).split('/').reverse().join('-');
}

const formatDateString = (date) => {
    const convertedDate = new Date(date);
    return convertedDate.toDateString();
}

const dateTimeToUTC = (dateInput) =>{
    const convertedTime = new Date(dateInput)
    return convertedTime.getTime()
}

const UTCToDateTime = (UTCInput) =>{
    const convertedTime = new Date(UTCInput)
    return convertedTime.toLocaleString()
}

export {formatDate, formatDateString , dateTimeToUTC, UTCToDateTime}